<template>
  <el-dialog
    :visible="true"
    :before-close="handleClose"
    :title="'预案' | translateTo(i18nPath)"
    width="65vw"
    class="device-plan"
    top="10vh"
  >
    <HTForm v-bind="formOptions" :i18nPath="i18nPath"></HTForm>
    <m-table
      :i18nPath="i18nPath"
      :loading="loading"
      :tableData="tableData"
      :tableColumn="tableColumn"
      :pagiOption="pagiOption"
      :oprateMenu="oprateMenu"
      max-height="calc(100% - 60px)"
      v-on:search="search"
      style="height: calc(100% - 60px)"
    ></m-table>
  </el-dialog>
</template>

<script>
import HTForm from '@/components/form';
import MTable from '@/components/mTable/m-table';
import { getPlanData } from '@/api/plan';
import { awaitTo } from '@/utils/utils';
import { downloadFileByUrl } from '@/utils/file';

import { previewFile } from '@/components/preview/index.js';
import { translateTo } from '@/utils/locale';

export default {
  components: {
    HTForm,
    MTable
  },
  props: {
    deviceType: {
      type: String,
      default: ''
    },
    container: {
      type: HTMLElement,
      default: () => document.body
    }
  },
  data() {
    const planLevel = [
      { label: '一级', value: 1 },
      { label: '二级', value: 2 },
      { label: '三级', value: 3 },
      { label: '四级', value: 4 }
    ];

    const planeMap = planLevel.reduce((map, e) => {
      map[e.value] = e.label;

      return map;
    }, {});

    const i18nPath = 'layout';

    return {
      i18nPath,
      loading: false,
      formOptions: {
        inline: true,
        config: {
          labelWidth: '',
          span: 6,
          options: [
            { type: 'input', prop: 'keyword', placeholder: '请输入关键字', label: '关键字' },
            { type: 'input', prop: 'name', placeholder: '请输入预案名称', label: '预案名称' },
            {
              type: 'select',
              prop: 'level',
              labelNeedTranslation: true,
              dataKey: 'planLevel',
              placeholder: '请选择预案等级',
              label: '预案等级'
            }
          ],
          operation: {
            span: 6,
            buttons: [
              {
                text: '查询',
                loading: false,
                type: 'primary',
                handler: async ({ setLoading }) => {
                  setLoading(true);
                  await this.search();
                  setLoading(false);
                }
              },
              {
                text: '重置',
                loading: false,
                type: 'primary',
                handler: async ({ setLoading }) => {
                  setLoading(true);
                  this.resetSearch();
                  setLoading(false);
                }
              }
            ]
          }
        },

        model: {
          keyword: '',
          name: '',
          level: ''
        },
        dataSource: {
          planLevel
        },
        rules: {
          keyword: [{ message: '请填写处理人员', trigger: 'blur' }],
          name: [{ message: '请填写处理人员', trigger: 'blur' }],
          level: [{ message: '请填写处理人员', trigger: 'blur' }]
        }
      },
      tableData: [],
      tableColumn: [
        { prop: 'keyword', label: '关键字' },
        { prop: 'name', label: '预案名称' },
        {
          prop: 'level',
          label: '预案等级',
          temp: ({ row }) => {
            return translateTo(planeMap[row.level], i18nPath);
          }
        }
      ],
      oprateMenu: {
        label: '操作',
        list: [
          {
            text: '查看',
            access: () => {
              return true;
            },
            event: (_index, data) => {
              previewFile({ url: data.file, fullscreen: true });
            }
          },
          {
            text: '下载',
            access: () => {
              return true;
            },
            event: (_index, data) => {
              downloadFileByUrl(data.file);
            }
          }
        ]
      },
      pagiOption: {
        offset: 1,
        limit: 10,
        total: 0,
        pagiSize: [10, 15, 20, 30],
        layout: 'total, sizes, prev, pager, next, jumper'
      }
    };
  },
  methods: {
    handleClose(done) {
      this.$destroy();
      done?.();
    },
    async resetSearch() {
      Object.assign(this.formOptions.model, {
        keyword: '',
        name: '',
        level: ''
      });

      this.pagiOption.offset = 1;

      await this.search();
    },
    async search() {
      if (this.loading) return;

      this.loading = true;

      const [err, res] = await awaitTo(
        getPlanData({
          ...this.formOptions.model,
          deviceTypeCode: [this.deviceType],
          offset: this.pagiOption.offset,
          limit: this.pagiOption.limit
        })
      );

      if (err) {
        this.$message.error(err.message);
      }

      this.tableData.splice(0, Infinity, ...res.data.list);

      this.pagiOption.total = res?.data?.total || 0;

      this.loading = false;
    }
  },
  mounted() {
    document.body.appendChild(this.$el);

    this.search();
  },
  destroyed() {
    // if appendToBody is true, remove DOM node after destroy
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>

<style lang="scss">
.device-plan {
  box-sizing: border-box;

  .el-dialog {
    height: calc(100vh - 20vh);

    &__body {
      height: calc(100% - 55px);
      box-sizing: border-box;
    }

    .m-table {
      height: calc(100% - 60px);

      .el-table {
        height: calc(100% - 55px);

        &__body-wrapper {
          height: calc(100% - 48px);
        }
      }
    }
  }
}
</style>
